<ion-card>
  <ion-card-header>
    <ion-card-title>Tudásbázis</ion-card-title>
    <ion-card-subtitle>A felhasználói kézikönyv generálása és közzététele</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content>
    <div *ngIf="toltodik"><ion-spinner name="dots"></ion-spinner> Betöltés…</div>

    <ng-container *ngIf="!toltodik">
      <ion-note color="medium" style="display:block;margin-bottom:14px">
        A tudásbázis tisztán statikus oldal: HTML, CSS és képek – nincs mögötte adatbázis
        és nincs bejelentkezés. Ezért <b>bárhová feltölthető</b>: az iskola honlapjára,
        SharePointra, saját tárhelyre – vagy egy gombbal ide, a rendszer fájltárába.
        A generálás a <b>mostani</b> állapotból dolgozik, tehát a menük magukkal frissülnek.
      </ion-note>

      <!-- Ha a generátor forrása nincs a helyén, azt ki kell mondani: enélkül a gomb
           csak nem csinálna semmit, és nem lenne miből megérteni, miért. -->
      <ion-note color="danger" *ngIf="!allapot?.elerheto" style="display:block;margin-bottom:14px">
        <b>A kézikönyv most nem generálható.</b><br>
        {{ allapot?.hiba }}
      </ion-note>

      <div *ngIf="allapot?.elerheto" class="tb-adatok">
        <div>
          <span>Legutóbbi generálás</span>
          <b *ngIf="allapot.keszult">{{ allapot.keszult | date:'yyyy. MM. dd. HH:mm' }}</b>
          <b *ngIf="!allapot.keszult">még nem futott</b>
        </div>
        <div><span>Fájlok</span><b>{{ allapot.darab ? allapot.darab + ' db' : '–' }}</b></div>
        <div><span>Méret</span><b>{{ meret(allapot.meret) }}</b></div>
        <div>
          <span>Utolsó közzététel</span>
          <b *ngIf="allapot.utolso_kozzetetel">
            {{ allapot.utolso_kozzetetel.mikor | date:'yyyy. MM. dd. HH:mm' }}
            <small *ngIf="allapot.utolso_kozzetetel.ki"> — {{ allapot.utolso_kozzetetel.ki }}</small>
          </b>
          <b *ngIf="!allapot.utolso_kozzetetel">még nem volt</b>
        </div>
      </div>

      <!--  AZ ADMIN FEJEZET ZÁRA.
            A kézikönyv nyilvános, és az is marad. Az admin fejezet viszont azt írja le,
            hogyan lehet jogosultságot adni, más nevében belépni, tanúsítványt cserélni –
            ezért zárható. A zár nem elrejtés: a fejezet szövege TITKOSÍTVA kerül a kész
            oldalra, és a keresőindexből is kimarad. -->
      <div class="tb-zar" *ngIf="allapot?.elerheto">
        <div class="tb-zar-fej">
          <b>Admin fejezet</b>
          <ion-chip *ngIf="zar?.van" color="success" class="tb-zar-chip">jelszóval védett</ion-chip>
          <ion-chip *ngIf="zar && !zar.van" color="medium" class="tb-zar-chip">nyilvános</ion-chip>
        </div>

        <ion-note color="medium" class="tb-zar-leiras">
          A kézikönyv többi fejezete bejelentkezés nélkül olvasható, és ez szándékos. Az
          admin fejezet viszont azt írja le, hogyan lehet <b>jogosultságot adni</b>, más
          nevében belépni, tanúsítványt cserélni, adatot importálni. Ha adsz jelszót, a
          generátor azt a fejezetet <b>titkosítva</b> teszi a kész oldalra, és a keresőből
          is kiveszi — vagyis jelszó nélkül a szöveg az oldal forrásából sem olvasható ki.
        </ion-note>

        <!--  A KÉT ÁLLAPOT SZÉTVÁLASZTÁSA. A jelszó beállítása önmagában nem ír át semmit
              a nyilvános oldalon: ott a korábbi generálásból származó kézikönyv van. Ha
              ezt nem mondjuk ki, az adminisztrátor azt hiszi, a zár már él. -->
        <ion-note color="warning" class="tb-zar-leiras"
                  *ngIf="zar?.van && allapot?.admin_zarolt_kozzetett === false">
          <b>A jelszó be van állítva, de a közzétett kézikönyv még nyílt.</b>
          A zár a következő <b>Generálás és közzététel</b> után él.
        </ion-note>

        <div class="tb-zar-urlap" *ngIf="zarLathato">
          <ion-input type="password" fill="outline" labelPlacement="stacked"
                     label="Új jelszó (legalább 8 karakter)" autocomplete="new-password"
                     [(ngModel)]="zarJelszo"></ion-input>
          <ion-input type="password" fill="outline" labelPlacement="stacked"
                     label="Még egyszer" autocomplete="new-password"
                     [(ngModel)]="zarJelszo2"></ion-input>
          <ion-button size="small" color="success" [disabled]="zarFut" (click)="zarMentes()">
            <ion-icon slot="start" name="lock-closed-outline"></ion-icon>
            {{ zarFut ? 'Mentés…' : 'Mentés' }}
          </ion-button>
          <ion-button size="small" fill="clear" color="medium" [disabled]="zarFut"
                      (click)="zarLathato = false; zarJelszo = ''; zarJelszo2 = ''">Mégse</ion-button>
        </div>

        <div class="tb-zar-gombok" *ngIf="!zarLathato">
          <ion-button size="small" fill="outline" [disabled]="zarFut" (click)="zarLathato = true">
            <ion-icon slot="start" name="key-outline"></ion-icon>
            {{ zar?.van ? 'Jelszó megváltoztatása' : 'Jelszó beállítása' }}
          </ion-button>
          <ion-button size="small" fill="clear" color="danger" *ngIf="zar?.van"
                      [disabled]="zarFut" (click)="zarTorles()">
            <ion-icon slot="start" name="lock-open-outline"></ion-icon>
            Zár feloldása
          </ion-button>
          <ion-note color="medium" *ngIf="zar?.modositva" class="tb-zar-mikor">
            beállítva: {{ zar.modositva | date:'yyyy. MM. dd. HH:mm' }}
          </ion-note>
        </div>

        <ion-note color="medium" class="tb-zar-apro">
          Ez <b>dokumentum-jelszó</b>, nem belépési jelszó: a generáláshoz magára a
          jelszóra van szükség, ezért a kiszolgálón visszafejthetően tárolódik (a
          felületnek viszont sosem adja vissza). Épp ezért <b>ne ugyanaz legyen</b>, mint
          bármelyik fiók jelszava. A titkosított fejezetet bárki letöltheti a nyilvános
          oldalról és offline próbálgathatja — ezen a rövid jelszót a kulcsszármaztatás
          sem menti meg.<br>
          A megnyitás a böngészőben <b>https-t</b> kíván: a fájlból (ZIP-ből kicsomagolva)
          megnyitott oldalon a Chrome nem ad titkosítási szolgáltatást. A nyilvános
          fejezetek fájlból is működnek.
        </ion-note>
      </div>

      <div class="tb-gombok">
        <ion-button color="primary" [disabled]="!allapot?.elerheto || fut || generalFut" (click)="kozzetesz()">
          <ion-icon slot="start" name="cloud-upload-outline"></ion-icon>
          {{ fut ? 'Közzététel folyamatban…' : 'Generálás és közzététel' }}
        </ion-button>
        <ion-button fill="outline" [disabled]="!allapot?.elerheto || fut || generalFut" (click)="general()">
          <ion-icon slot="start" name="refresh-outline"></ion-icon>
          {{ generalFut ? 'Generálás…' : 'Csak generálás (nézzük meg)' }}
        </ion-button>
        <ion-button fill="outline" color="medium" [disabled]="!allapot?.elerheto || fut || generalFut" (click)="letoltes()">
          <ion-icon slot="start" name="download-outline"></ion-icon>
          Letöltés ZIP-ben
        </ion-button>
      </div>

      <!-- ELTÉRÉSEK: nem hibalista, hanem munkalista. A generátor összeveti a
           kézikönyvet a futó rendszerrel, és megmondja, mi az, amit még nem ír le. -->
      <div class="tb-elteres" *ngIf="elteresek">
        <div class="tb-elteres-fej">
          <div>
            <b *ngIf="vanEltereses">A kézikönyv és a rendszer eltér</b>
            <b *ngIf="!vanEltereses">A kézikönyv lefedi a rendszert</b>
            <span>
              {{ elteresek.osszesen.uj }} még nem leírt képernyő ·
              {{ elteresek.osszesen.megszunt }} elavult szakasz ·
              {{ elteresek.osszesen.kep_nelkul }} kép nélkül
            </span>
          </div>
          <ion-button size="small" fill="clear" (click)="reszletek = !reszletek">
            {{ reszletek ? 'Elrejt' : 'Részletek' }}
          </ion-button>
        </div>

        <ion-note color="medium" *ngIf="allapot?.rendszer && !allapot.rendszer.felulet_forras"
                  style="display:block;font-size:12px;margin-top:6px">
          Az admin aloldalait most nem tudtuk beolvasni ({{ allapot.rendszer.felulet_ok }}),
          ezért csak a bal menü szerepel az összevetésben.
        </ion-note>

        <div *ngIf="reszletek" class="tb-elteres-test">
          <div *ngIf="!vanEltereses" class="tb-ures">
            Minden képernyőnek van fejezete. A „kép nélkül” azokat a szakaszokat jelenti,
            ahol rajzolt ábra van valódi képernyőkép helyett – az nem hiba.
          </div>

          <div *ngFor="let cs of ujKepernyok" class="tb-csoport">
            <h4>{{ cs.szerep }} — {{ cs.tetelek.length }} még nem leírt képernyő</h4>
            <ul>
              <li *ngFor="let t of cs.tetelek">
                <b>{{ t.cim }}</b>
                <code>{{ t.ut }}</code>
                <span *ngIf="t.csoport">{{ t.csoport }}</span>
              </li>
            </ul>
          </div>

          <div *ngFor="let cs of elavultSzakaszok" class="tb-csoport tb-elavult">
            <h4>{{ cs.szerep }} — {{ cs.tetelek.length }} szakasz olyan képernyőről, ami már nincs</h4>
            <ul>
              <li *ngFor="let t of cs.tetelek"><b>{{ t.cim }}</b><code>{{ t.ut }}</code></li>
            </ul>
          </div>
        </div>
      </div>

      <!-- A nyilvános cím akkor is látszik, ha most nem publikáltunk: ez az, amit
           meg lehet osztani, és ez az, amit ellenőrizni érdemes. -->
      <div class="tb-link" *ngIf="allapot?.nyilvanos_url">
        <span>Nyilvános cím a fájltárban:</span>
        <a [href]="allapot.nyilvanos_url" target="_blank" rel="noopener">{{ nyilvanosCim }}</a>
        <ion-button size="small" fill="clear" (click)="masol()">
          <ion-icon slot="icon-only" name="copy-outline"></ion-icon>
        </ion-button>
      </div>

      <div class="tb-eredmeny" *ngIf="eredmeny">
        <b>{{ eredmeny.feltoltve }}</b> fájl feltöltve ({{ meret(eredmeny.meret) }}).
        <span *ngIf="eredmeny.hibas?.length" style="color:#b42318">
          {{ eredmeny.hibas.length }} fájl kimaradt:
          {{ eredmeny.hibas[0].ut }} — {{ eredmeny.hibas[0].hiba }}
        </span>
      </div>

      <ion-note color="medium" style="display:block;margin-top:16px">
        <b>A letöltött csomag önmagában működik.</b> Kicsomagolva, webkiszolgáló nélkül,
        dupla kattintással is megnyílik, és a keresés is megy benne – a hivatkozásai
        relatívak, tehát alkönyvtárba téve is jó. Feltöltéskor az <code>index.html</code>
        a nyitólap.
      </ion-note>
      <ion-note color="medium" style="display:block;margin-top:8px">
        <b>A közzététel nem töröl.</b> A meglévő fájlok felülíródnak, a régiek maradnak.
        Így egy félbeszakadt feltöltés nem hagyja darabokban az oldalt: amíg az új be nem
        fejeződik, a korábbi változat működik tovább.
      </ion-note>
    </ng-container>
  </ion-card-content>
</ion-card>
